/**
 * Test IDs for QA automation.
 */
export const testIds = {
  transactionTemplatesModalSubmit: "transaction-templates-modal-submit",
} as const;
